import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import About from './views/About.vue'
// import Contact from './views/Contact.vue'
// import ProductItem from './views/ProductItem.vue'
// import WebItem from './views/WebItem.vue'
// import ServicePlatformItem from './views/ServicePlatformItem.vue'
import Error404 from '@/views/404.vue'

Vue.use(Router)

export default new Router({
  // mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // {
    //   path: '/projects',
    //   name: 'projects',
    //   component: Home
    // },
    // {
    //   path: '/projects/product-design/:project_name',
    //   name: 'productItem',
    //   component: ProductItem
    // },
    // {
    //   path: '/projects/web-design/:project_name',
    //   name: 'webItem',
    //   component: WebItem
    // },
    // {
    //   path: '/projects/service-design/:project_name',
    //   name: 'servicePlatformItem',
    //   component: ServicePlatformItem
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: About
    // },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: Contact
    // },
    {
      path: '*',
      name: 'Error404',
      component: Error404
    },
    {
      path: '/error',
      name: 'Error404Page',
      component: Error404
    }
  ]
})
